<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="6">
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách menu</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                                :select-options="{ enabled: true }" :totalRows="totalRecords"
                                mode="remote"
                                @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <!-- Table Top -->
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách sub menu</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQueryTopic" placeholder="Tìm kiếm "
                                v-on:keydown.enter="quickTopicSearch"/>
                  <b-input-group-append is-text role="button" @click="quickTopicSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fieldSubs" :isLoading.sync="isLoading" :line-numbers="true" :rows="itemSubs"
                                :select-options="{ enabled: true }" :totalRows="totalRecordSubs"
                                mode="remote" @on-page-change="onPageChangeSub"
                                @on-sort-change="onSortChangeSub" @on-column-filter="onColumnSubFilter"
                                @on-per-page-change="onPerPageChangeSub"
                                @on-selected-rows-change="selectionChangedSub">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary"
                                  @click="EditTopic(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" size="xl" title="Cập nhật menu" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Tên menu <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItem.category_name" :state="validateState('category_name')" placeholder="Nhập tên menu"
                            required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Trạng thái <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')"/>
            </b-form-group>
          </b-col>

        </b-row>
      </form>
    </b-modal>
    <b-modal id="modal-edit-topic" size="xl" title="Cập nhật menu con" @ok="handleTopicOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Chọn menu cha<span class='text-danger'>*</span></label>
              <Select2 v-model="currentItemSub.parent_id" :options="categoriesSelect" :state="validateStateSub('parent_id')"
                       required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Tên menu con <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItemSub.category_name" :state="validateStateSub('category_name')" minlength="3"
                            placeholder="Nhập tên menu con"
                            required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Trạng thái <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItemSub.status" :options="statusList" :state="validateStateSub('status')"
                       required/>
            </b-form-group>
          </b-col>

        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    validateStateSub(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItemSub[pro]) return false;
      else return true;
      return null;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    //sub
    updateSubParams(newProps) {
      this.serverSubParams = Object.assign({}, this.serverSubParams, newProps);
    },
    onPageChangeSub(params) {
      this.updateSubParams({page: params.currentPage});
      this.quickTopicSearch();
    },
    onPerPageChangeSub(params) {
      this.updateSubParams({pageSize: params.currentPerPage});
      this.quickTopicSearch();
    },
    onSortChangeSub(params) {
      this.updateSubParams({
        sort: params,
      });
      this.quickTopicSearch();
    },
    onColumnSubFilter(params) {
      this.serverSubParams.page = 1;
      this.updateSubParams(params);
      console.log(this.serverParams);
      this.quickTopicSearch();
    },
    //sub
    loadItems() {
      try {
        this.loading(true);
        useJwt
            .get("baseus-admin/subcategories", {
              columnFilters: {},
            })
            .then((response) => {
              this.loading(false);
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
              this.categoriesSelect = [];
              this.items.forEach(item => {
                this.categoriesSelect.push({'id': item.id, 'text': item.category_name});
              });
            });
      } catch {
        this.loading(false);
      }

    },
    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật menu";
      this.$bvModal.show("modal-edit");
    },

    async EditTopic(item) {
      this.currentItemSub = item;
      this.editMode = true;
      this.modal_title = "Cập nhật menu con";
      this.$bvModal.show("modal-edit-topic");
    },

    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
      this.quickTopicSearch();
    },

    selectionChangedSub(params) {
      this.rowSelectionSub = params.selectedRows;
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }
      const url = `baseus-admin/categories/${this.currentItem.id}`;

      const updateParams = {
        id: this.currentItem.id,
        category_name: this.currentItem.name,
        status: this.currentItem.status,
        parent_id: this.currentItem.parent_id,
        sort_order: this.currentItem.sort_order,
        filter_config: this.currentItemSub.filter_config
      };
      try {
        this.loading(true);
        const res = await useJwt.put(url, updateParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadItems();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("modal-edit");

        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi cập nhật menu ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });

      }
    },
    async handleTopicOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const parentId = this.currentItemSub.parent_id;
      const parent = this.items.filter(function (item) {
        return item.id == parentId
      })[0];
      if (Object.keys(parent).length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn menu.!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return;
      }
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItemSub);
      if (!bIsValid) {
        return;
      }

      const url = `baseus-admin/categories/${this.currentItemSub.id}`;

      const updateParams = {
        id: this.currentItemSub.id,
        category_name: this.currentItemSub.category_name,
        status: this.currentItemSub.status,
        parent_id: this.currentItemSub.parent_id,
        sort_order: this.currentItemSub.sort_order,
        filter_config: this.currentItemSub.filter_config
      };
      try {
        this.loading(true);
        const res = await useJwt.put(url, updateParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.quickTopicSearch();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("modal-edit-topic");

        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi cập nhật topic ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });

      }
    },
    async isValid(item) {
      if (!item.category_name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }


      return true;
    },
    async loadCategories() {
      try {
        this.loading(true);
        useJwt.get("baseus-admin/subcategories?filter=" + this.searchQuery).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
            this.categoriesSelect = [];
            this.items.forEach(item => {
              this.categoriesSelect.push({'id': item.id, 'text': item.category_name});
            });
          }

          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }

    },
    async quickSearch() {
      this.loadCategories();
    },
    async quickTopicSearch() {
      try {

        this.loading(true);
        let listCatIds = [];
        this.rowSelection.forEach(function (item) {
          listCatIds.push(item.id);
        });
        useJwt.get("baseus-admin/getChildrents?filter=" + this.searchQuery + '&ids=' + listCatIds).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.itemSubs = result.result;
            this.totalRecordSubs = result.totalRecords;
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    }
  },

  mounted() {
    this.loadCategories();
    this.quickTopicSearch();
    this.isSubmit = false;
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      totalRecordSubs: 0,
      items: [],
      itemSubs: [],
      statusList: [
        {id: 1, text: "Hoạt động"},
        {id: 0, text: "Không hoạt động"}
      ],

      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchQueryTopic: "",
      currentItem: {},
      currentItemSub: {},
      categoriesSelect: [],
      rowSelection: [],
      rowSelectionSub: [],
      options: {
        fields: [
          {field: "action", label: "Thao tác", width: "120px"},
          {
            field: "category_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên menu",
            required: true,
            disabled: true,
          },

          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          },
          {
            field: "slug",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Đường dẫn",
            required: true,
            disabled: true,
          },
          {
            field: "level",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Cấp",
            required: true,
            disabled: true,
          },
          {
            field: "origin_type",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Loại",
            required: true,
            disabled: true,
          }
        ],
        fieldSubs: [
          {field: "action", label: "Thao tác", width: "120px"},
          {
            field: "category_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên menu",
            required: true,
            disabled: true,
          },

          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          },
          {
            field: "slug",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Đường dẫn",
            required: true,
            disabled: true,
          },
          {
            field: "level",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Cấp",
            required: true,
            disabled: true,
          },
          {
            field: "origin_type",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Loại",
            required: true,
            disabled: true,
          }
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.readonly {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

table.vgt-table td {
  min-width: 100px;
}

.modal-content {
  width: 70% !important;
  margin: 0 auto;
}
</style>
